import { UploadItemType } from '@thesavingsgroup/enums/UploadItemType';
import i18n from 'i18next';

import { FeatureFlag } from '../../featureStore/enums/FeatureFlag';
import useFeatureStore from '../../featureStore/useFeatureStore';
import { UploadItem } from '../types/UploadItem';
import { Verification } from '../types/Verification';

export const getVerifications = ({
  vehicleApplicationHasCoapplicant,
  vehicleApplicationIsLeaseBuyoutType,
  vehicleApplicationIsRefinanceType,
  vehicleId,
}: {
  vehicleApplicationHasCoapplicant: boolean;
  vehicleApplicationIsLeaseBuyoutType: boolean;
  vehicleApplicationIsRefinanceType: boolean;
  vehicleId: string;
}): Verification[] =>
  [
    new Verification({
      copy: i18n.t('verifications.applicantDriversLicense.copy'),
      headline: i18n.t('verifications.applicantDriversLicense.headline'),
      name: i18n.t('verifications.applicantDriversLicense.name'),
      path: `/verifications/${vehicleId}/upload-license`,
      uploadItems: [
        new UploadItem(UploadItemType.APPLICANT_FRONT_OF_LICENSE),
        new UploadItem(UploadItemType.APPLICANT_BACK_OF_LICENSE),
      ],
    }),
    new Verification({
      condition: vehicleApplicationHasCoapplicant,
      copy: i18n.t('verifications.coapplicantDriversLicense.copy'),
      headline: i18n.t('verifications.coapplicantDriversLicense.headline'),
      name: i18n.t('verifications.coapplicantDriversLicense.name'),
      path: `/verifications/${vehicleId}/coapp-upload-license`,
      uploadItems: [
        new UploadItem(UploadItemType.CO_APPLICANT_FRONT_OF_LICENSE),
        new UploadItem(UploadItemType.CO_APPLICANT_BACK_OF_LICENSE),
      ],
    }),
    new Verification({
      copy: i18n.t('verifications.proofOfInsurance.copy'),
      headline: i18n.t('verifications.proofOfInsurance.headline'),
      name: i18n.t('verifications.proofOfInsurance.name'),
      path: `/verifications/${vehicleId}/upload-insurance`,
      uploadItems: [new UploadItem(UploadItemType.PROOF_OF_INSURANCE)],
    }),
    new Verification({
      condition:
        vehicleApplicationIsRefinanceType ||
        vehicleApplicationIsLeaseBuyoutType,
      copy: i18n.t('verifications.registrationCard.copy'),
      headline: i18n.t('verifications.registrationCard.headline'),
      name: i18n.t('verifications.registrationCard.name'),
      path: `/verifications/${vehicleId}/upload-registration`,
      uploadItems: [new UploadItem(UploadItemType.REGISTRATION_CARD)],
    }),
    new Verification({
      condition:
        vehicleApplicationIsRefinanceType ||
        vehicleApplicationIsLeaseBuyoutType,
      copy: i18n.t('verifications.photoOfOdometer.copy'),
      headline: i18n.t('verifications.photoOfOdometer.headline'),
      name: i18n.t('verifications.photoOfOdometer.name'),
      path: `/verifications/${vehicleId}/upload-odometer`,
      uploadItems: [new UploadItem(UploadItemType.PHOTO_OF_ODOMETER)],
    }),
    new Verification({
      condition: useFeatureStore
        .getState()
        .isEnabled(FeatureFlag.ENABLE_INCOME_VERIFICATION_UPLOAD),
      copy: i18n.t('verifications.proofOfIncome.copy'),
      headline: i18n.t('verifications.proofOfIncome.headline'),
      name: i18n.t('verifications.proofOfIncome.name'),
      path: `/verifications/${vehicleId}/upload-income`,
      uploadItems: [new UploadItem(UploadItemType.PROOF_OF_INCOME)],
    }),
    new Verification({
      condition:
        vehicleApplicationHasCoapplicant &&
        useFeatureStore
          .getState()
          .isEnabled(FeatureFlag.ENABLE_INCOME_VERIFICATION_UPLOAD),
      copy: i18n.t('verifications.coapplicantProofOfIncome.copy'),
      headline: i18n.t('verifications.coapplicantProofOfIncome.headline'),
      name: i18n.t('verifications.coapplicantProofOfIncome.name'),
      path: `/verifications/${vehicleId}/coapp-upload-income`,
      uploadItems: [
        new UploadItem(UploadItemType.PROOF_OF_INCOME_CO_APPLICANT),
      ],
    }),
    new Verification({
      continuousUploads: true,
      copy: i18n.t('verifications.additionalDocuments.copy'),
      headline: i18n.t('verifications.additionalDocuments.headline'),
      isOptional: true,
      name: i18n.t('verifications.additionalDocuments.name'),
      path: `/verifications/${vehicleId}/upload-additional`,
      uploadItems: [new UploadItem(UploadItemType.ADDITIONAL_DOCUMENT)],
    }),
  ].filter((verification): boolean => verification.condition);
